import React from 'react';

import { ChatViewDriver } from '../../ChatViewDriver';

export function ChatModal({ open, onClose, chatId }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-2xl h-[80vh] overflow-hidden flex flex-col relative">
        <ChatViewDriver chatId={chatId} onBackClick={onClose} />
      </div>
    </div>
  );
}